import React from "react";

const facilities = [
  {
    title: "Room Service",
    description: "Enjoy 24/7 in-room dining with comfort, convenience, and a wide selection of freshly prepared meals.",
    icon:"/images/amenities/new/icon/2b.png" ,
    img:"/images/amenities/new/amenitiesArtboard-5.jpg"
  },
  {
    title: "Pick & Drop",
    description: "Enjoy hassle-free travel with our complimentary airport pick-up and drop-off service.",
    icon: "/images/amenities/new/icon/1b.png",
    img:"/images/amenities/new/amenitiesArtboard-1.jpg"
  },
  {
    title: "WiFi",
    description: "Stay connected with high-speed wireless internet access available across the hotel.",
    icon: "/images/amenities/new/icon/3b.png",
    img:"/images/amenities/new/amenitiesArtboard-4.jpg"
  },
  {
    title: "Breakfast",
    description: "Start your day with a gourmet breakfast buffet featuring a variety of local and international dishes.",
    icon: "/images/amenities/new/icon/4b.png",
    img:"/images/amenities/new/amenitiesArtboard-3.jpg"
  },
  {
    title: "Swimming Pool",
    description: "Take a refreshing dip in our serene pool area, perfect for relaxation and leisure.",
    icon: "/images/amenities/new/icon/5b.png",
    img:"/images/amenities/new/amenitiesArtboard-2.jpg"
  },
  {
    title: "Parking Space",
    description: "Avail of our secure on-site parking for all your vehicular needs.",
    icon: "/images/amenities/new/icon/6b.png",
    img:"/images/amenities/new/amenitiesArtboard-6.jpg"
  },
  {
    title: "Wheel Chair",
    description: "We provide wheelchairs for guests with mobility challenges to ensure a comfortable stay.",
    icon: "/images/amenities/new/icon/7b.png",
    img:"/images/amenities/new/amenitiesArtboard-7.jpg"
    
  },
  {
    title: "Aero Stag",
    description: "Immerse yourself in a unique culinary experience at Aerostag Restaurant, where poolside dining meets refined ambiance.",
    icon: "/images/amenities/new/icon/8b.png",
    img:"/images/amenities/new/amenitiesArtboard-8.jpg"
  },
];

const Amenities = () => {
  return (
    <div className="facilities-container">
      <h2 className="facilities-title">AMENITIES</h2>
      <div className="facilities-grid">
        {facilities.map((item, index) => (
          <div key={index} className="facility-card" style={{background:`url(${item.img})`, objectFit:"fill"}}>
            <div className="facility-icon">
              <img src={item.icon} alt={`V Hotel The Grnad Shoba-free ${item.title}`} title="V Hotel The Grnad Shoba Amenitites"   height={90} width={90}/>
            </div>
            <h3 className="facility-title">{item.title}</h3>
            <p className="facility-description">{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Amenities;
